import React, { useState } from "react"; // 1. Import useState
import { mockCreator } from "../../../data/mockData";
import AdminDataTable from "../../admin/components/AdminDataTable";
import Button from "../../../components/ui/Button";
import Input from "../../../components/ui/Input";
import Card from "../../../components/ui/Card";
import CreateGroupModal from "../components/modals/CreateGroupModal";
import { UserPlus, Search } from "lucide-react";

const AudienceCRMPage = () => {
  // 2. Add state for audience list and modal visibility
  const [audience, setAudience] = useState(mockCreator.audienceList);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // 3. Add function to handle saving a new group
  const handleSaveGroup = ({ groupName, memberIds }) => {
    setAudience((currentAudience) =>
      currentAudience.map((user) => {
        if (memberIds.includes(user.id)) {
          const newGroups = new Set([...user.groups, groupName]);
          return { ...user, groups: Array.from(newGroups) };
        }
        return user;
      })
    );
  };

  // 4. Update the "Groups" column to render styled badges
  const audienceColumns = [
    {
      header: "Username",
      key: "username",
      render: (row) => (
        <p className="font-medium text-slate-800">@{row.username}</p>
      ),
    },
    {
      header: "Status",
      key: "status",
      render: (row) => (
        <span className="px-2 py-1 text-xs font-semibold rounded-full bg-purple-100 text-purple-700">
          {row.status}
        </span>
      ),
    },
    {
      header: "Last Interaction",
      key: "lastInteraction",
      render: (row) => (
        <div>
          <p className="text-slate-800">{row.lastInteraction}</p>
          <p className="text-xs text-slate-500">{row.date}</p>
        </div>
      ),
    },
    {
      header: "Groups",
      key: "groups",
      render: (row) =>
        row.groups.length > 0 ? (
          row.groups.map((g) => (
            <span
              key={g}
              className="mr-1 mb-1 inline-block px-2 py-0.5 text-xs font-semibold rounded-full bg-slate-200 text-slate-700"
            >
              {g}
            </span>
          ))
        ) : (
          <span className="text-slate-400">No groups</span>
        ),
    },
  ];

  return (
    // 8. Wrap everything in a Fragment to render modal as a sibling
    <>
    <div className="space-y-6 max-w-full overflow-hidden">
        <div className="flex flex-col @md:flex-row justify-between items-start @md:items-center gap-4">
          <div>
            <h1 className="text-2xl @sm:text-3xl font-bold text-slate-800">Audience</h1>
            <p className="text-slate-500 mt-1 text-sm @sm:text-base">
              Manage your community of fans and followers.
            </p>
          </div>
          <Button variant="primary" onClick={() => setIsModalOpen(true)} className="w-full @md:w-auto">
            <UserPlus size={16} className="mr-2" /> Create Group
          </Button>
        </div>

        <Card className="!p-0 border-none shadow-none bg-transparent">
            <div className="relative mb-6">
                <Input
                    placeholder="Search your audience by username..."
                    className="pl-10"
                />
                <Search
                    size={20}
                    className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
                />
            </div>

            <AdminDataTable columns={audienceColumns} data={audience} />
        </Card>
      </div>

      {/* 7. Render the modal */}
      <CreateGroupModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSave={handleSaveGroup}
      />
    </>
  );
};

export default AudienceCRMPage;
